import { ValidationResult } from '../formField/types/form-validator';
import { isEqual } from 'lodash';

export const NotInValuesValidator = <T>(forbiddenValues: T[], errorMessage: string) => {
  return async (value: T): Promise<ValidationResult> => {
    if (typeof value === 'string') {
      if (forbiddenValues.includes(value)) {
        return { valid: false, error: errorMessage };
      }

      return { valid: true };
    }

    for (const forbiddenValue of forbiddenValues) {
      if (!isEqual(forbiddenValue, value)) {
        continue;
      }

      return { valid: false, error: errorMessage };
    }

    return { valid: true };
  };
};
